import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "../../helpers/commonFunction";
import { reqToSendOTP, reqToVerifySendOTP } from "../../store/slice/userSlice";
import { Loader } from "../../components";
import { Button, Form } from "react-bootstrap";

const MedRepLogin = () => {
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => state.userReducer);

  const [step, setStep] = useState("sendOTP");
  const [formData, setFormData] = useState({
    email: null,
    otp: null,
  });
  const [timer, setTimer] = useState(30);
  const [isResendEnabled, setIsResendEnabled] = useState(false);

  useEffect(() => {
    let interval = null;
    if (step === "verifyOTP" && timer > 0 && !isResendEnabled) {
      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            setIsResendEnabled(true);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [step, timer, isResendEnabled]);

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendOTP = (e) => {
    e.preventDefault();
    if (step === "sendOTP") {
      if (formData?.email) {
        dispatch(
          reqToSendOTP({
            data: { email: formData.email },
            onSuccess: () => {
              setStep("verifyOTP");
              setTimer(30);
              setIsResendEnabled(false);
            },
          })
        );
      } else {
        notify("Please enter register email!");
      }
    } else {
      if (formData?.otp) {
        dispatch(
          reqToVerifySendOTP({
            data: {
              email: formData.email,
              otp: formData.otp,
            },
            onSuccess: () => {
              setFormData({ email: null, otp: null });
            },
          })
        );
      } else {
        notify("Please enter OTP!");
      }
    }
  };

  const handleResendOTP = () => {
    if (formData?.email) {
      dispatch(
        reqToSendOTP({
          data: { email: formData.email },
          onSuccess: () => {
            setTimer(30);
            setIsResendEnabled(false);
          },
        })
      );
    } else {
      notify("Please enter register email!");
    }
  };

  return (
    <>
      {loader && <Loader />}
      <div className="lms-navbar">
        <div className="lms-navbar-content"></div>
      </div>
      <div className="lms-body-wrapper">
        <div className="lms-container">
          <div className="lms-body">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <div className="lms-profile-wrapper mb-0">
                <span className="lms-profile-name">Login</span>
              </div>
            </div>
            <div className="lms-content-wrapper lms-content-text d-flex flex-column align-items-center justify-content-center">
              <div className="login-container shadow border-3 py-4 px-4 rounded-3">
                {step === "sendOTP" ? (
                  <>
                    <div className="login-header">
                      <h1>Login for your MEPI Training</h1>
                    </div>
                    <div className="login-body mt-5 px-5">
                      <Form className="d-flex flex-column justify-content-center input-group">
                        <Form.Group
                          className="mb-4 d-flex align-items-center gap-3 justify-content-center"
                          controlId="email"
                        >
                          <Form.Label className="mb-0">
                            Email <span>:</span>
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter register email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                        <Button
                          type="submit"
                          variant="primary"
                          className="mx-auto"
                          onClick={handleSendOTP}
                        >
                          NEXT
                        </Button>
                      </Form>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="login-header text-center d-flex flex-column justify-content-center gap-3 ">
                      <h1 className="mb-3">Check your email</h1>
                      <p>
                        Enter the 4-letter code that was sent to <br />
                        <span className="primary-text">
                          {formData?.email}
                        </span>{" "}
                        to finish your login.
                      </p>
                    </div>
                    <div className="login-body lms-otp-from mt-5 px-5">
                      <Form className="d-flex flex-column justify-content-center input-group">
                        <Form.Group
                          className="mb-4 d-flex justify-content-center mx-auto"
                          controlId="otp"
                        >
                          <Form.Control
                            type="number"
                            name="otp"
                            placeholder="Enter code"
                            value={formData.otp}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                        <Button
                          type="submit"
                          variant="primary"
                          className="mx-auto"
                          onClick={handleSendOTP}
                        >
                          Login
                        </Button>
                      </Form>
                    </div>
                    <p className="mt-3 fs-7">
                      Didn't receive the code?{" "}
                      {isResendEnabled ? (
                        <button
                          type="button"
                          className="btn btn-link p-0 m-0 align-baseline"
                          onClick={handleResendOTP}
                        >
                          Resend code
                        </button>
                      ) : (
                        <b className="primary-text">Resend code in {timer}s</b>
                      )}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedRepLogin;
